/**
 *@author shaolei
 *@date 2020/04/07
 *@file_name:api
 *@Description:api订阅
 */
<template>
  <div class="api">
    <div v-show="isAuth == 2" class="tabs">
      <div @click="changeTab(1)" :class="tab_index == 1 ? 'active' : ''" class="tab">申请中API</div>
      <div @click="changeTab(2)" :class="tab_index == 2 ? 'active' : ''" class="tab">可订阅API</div>
    </div>
    <div v-show="isAuth == 2" class="list">
      <!-- 申请中列表 -->
      <div v-show="tab_index == 1" class="table">
        <el-table
          :data="apisAlreadySubscription.tableData"
          border
          size="mini"
          style="width: 100%;min-height:48.7vh"
        >
          <el-table-column prop="apiName" header-align="center" align="left" label="API名称" width="150">
            <template slot-scope="scope">
              <el-link class="link" @click="toDetails(scope.row)" v-if="(scope.row.docId!=null || scope.row.docId!=0)&& scope.row.isLimitIp ==1">{{ scope.row.apiName }}</el-link>
              <span v-else-if="(scope.row.docId!=null || scope.row.docId!=0) && scope.row.isLimitIp !=1"  class="hasWhites" @click="toDetails(scope.row)">{{scope.row.apiName}}
                <el-tooltip class="item" effect="dark" content="该接口必须配置IP白名单" placement="top">
                  <i class="el-icon-warning"></i>
                </el-tooltip>
              </span>
              <span v-else>{{scope.row.apiName}}</span>
            </template>
          </el-table-column>
          <el-table-column label="API说明" header-align="center" align="left" prop="apiDesc" width="300"></el-table-column>
          <el-table-column prop="apiType" header-align="center" align="left" label="API类型"></el-table-column>
          <el-table-column prop="limitIp" header-align="center" align="left" label="IP"></el-table-column>
          <el-table-column width="165" header-align="center" align="left" label="操作">
            <template slot-scope="scope">
              <div class="ops">
                <el-button size="mini" @click="remove(scope.row)" v-show="tab_index == 1" >取消申请</el-button>
                <!-- <div @click="remove(scope.row)" v-show="tab_index == 1" class="btn del">取消申请</div> -->
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="page">
          <el-pagination
            background
            @size-change="sizeChange"
            @current-change="currentChange"
            :current-page="apisAlreadySubscription.page"
            :page-sizes="[10, 20, 30]"
            :page-size="apisAlreadySubscription.pageSize"
            layout="sizes, prev, pager, next, jumper, total"
            :total="apisAlreadySubscription.total"
          ></el-pagination>
        </div>
      </div>
      <!-- 可订阅列表 -->
      <div v-show="tab_index == 2" class="table">
        <el-table
          :data="apisCanSubscription.tableData"
          border
          size="mini"
          style="width: 100%;min-height:48.7vh"
        >
          <el-table-column label="API名称" header-align="center" align="left" width="150">
            <template slot-scope="scope">
              <el-link class="link" @click="toDetails(scope.row)" v-if="(scope.row.docId!=null || scope.row.docId!=0)&& scope.row.isLimitIp ==1">{{ scope.row.apiName }}</el-link>
              <span v-else-if="(scope.row.docId!=null || scope.row.docId!=0) && scope.row.isLimitIp !=1"  class="hasWhites" @click="toDetails(scope.row)">{{scope.row.apiName}}
                <el-tooltip class="item" effect="dark" content="该接口必须配置IP白名单" placement="top">
                  <i class="el-icon-warning"></i>
                </el-tooltip>
              </span>
              <span v-else>{{scope.row.apiName}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="apiDesc" header-align="center" align="left" label="API说明" width="300"></el-table-column>
          <el-table-column prop="apiType" header-align="center" align="left" label="API类型"></el-table-column>
          <!-- <el-table-column  header-align="center" align="left" label="订阅状态">
            <template slot-scope="scope">
              <div v-show="scope.row.apiAuditStatus == 0" class="status subing">
                <span></span>可订阅
              </div>
              <div v-show="scope.row.apiAuditStatus == 1" class="status nosub">
                <span></span>订阅审核中
              </div>
              <div v-show="scope.row.apiAuditStatus == 2" class="status pass">
                <span></span>已订阅
              </div>
              <div v-show="scope.row.apiAuditStatus == 3" class="status unpass">
                <span></span>审核不通过
              </div>
            </template>
          </el-table-column> -->
          <el-table-column width="100" header-align="center" align="center" label="操作">
            <template slot-scope="scope">
              <div class="ops">
                <!-- <div
                  :class="scope.row.apiAuditStatus == 2 || scope.row.apiAuditStatus == 1 ? 'no' : ''"
                  @click="add(scope.row)"
                  v-show="tab_index == 2"
                  class="btn"
                >{{scope.row.apiAuditStatus==0?'申请':scope.row.apiAuditStatus==3?'重新申请':''}}</div> -->
                <el-button size="mini" 
                 @click="add(scope.row)"
                 v-show="tab_index == 2"
                >{{scope.row.apiAuditStatus==0?'申请':scope.row.apiAuditStatus==3?'重新申请':''}}</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="page">
          <el-pagination
            background
            @size-change="sizeChange"
            @current-change="currentChange"
            :current-page="apisCanSubscription.page"
            :page-sizes="[10, 20, 30]"
            :page-size="apisCanSubscription.pageSize"
            layout="sizes, prev, pager, next, jumper, total"
            :total="apisCanSubscription.total"
          ></el-pagination>
        </div>
      </div>
      <!-- <div v-show="tab_index == 1" class="sub">
        <div @click="subReview" class="btn">提交审核</div>
      </div>-->
    </div>
    <div v-show="isAuth == 1" class="noAuth">
      <img src="@/assets/images/console-empty.png" alt />
      <div class="e">请先进行企业认证</div>
      <div @click="toLink('/account/company')" class="btn">立即认证</div>
    </div>
    <el-dialog
      class="sub_success"
      top="250px"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="isSub"
      width="320px"
      center
    >
      <div class="content">
        <img src="@/assets/images/sub_success.png" alt />
        <div class="tips">
          <div class="title">提交审核</div>
          <div>API已提交审核，审核通过后</div>
          <div>请在订阅管理查看</div>
        </div>
      </div>
      <div @click="Refresh()" class="btn">返回</div>
    </el-dialog>
    <el-dialog
      :title="selfconfig.title"
      :visible.sync="addipGroup"
      :before-close="handleClose"
      :close-on-click-modal = false
      width="570px"
      center
    >
      <div class="diaBody">
        <ul class="diatop">
          <li>
            <p class="left">API名称</p>
            <p class="right">{{digdata.apiName}}</p>
          </li>
          <li>
            <p class="left">API类型</p>
            <p class="right">{{digdata.apiType}}</p>
          </li>
          <li>
            <p class="left">API说明</p>
            <p class="right">{{digdata.apiDesc}}</p>
          </li>
        </ul>
        <div class="digbottom">
          <div class="b_left">指定IP</div>
          <div class="b_right">
            <el-form :model="addForm" size="small" ref="dtform">
              <el-form-item prop="one" :rules="selfconfig.isLimitIp == 1 ? ruleForm.one : ruleForm.oneIP">
                <el-input placeholder="限定只有此ip可调用" v-model="addForm.one"></el-input>
              </el-form-item>
              <div class="moreRules">
                <div class="moreRulesIn" v-for="(item,index) in addForm.moreInput" :key="index">
                  <el-form-item :prop="'moreInput.' + index +'.value'" :rules="selfconfig.isLimitIp == 1 ? selfrule.Ipruleone : selfrule.IpruleoneIP">
                    <el-input placeholder="限定只有此ip可调用" v-model="item.value"></el-input>
                  </el-form-item>
                </div>
              </div>
            </el-form>
          </div>
          <div class="b_btns">
            <p @click="addinput">
              <i class="el-icon-plus"></i>
            </p>
            <p @click="removeinput">
              <i class="el-icon-minus"></i>
            </p>
          </div>
        </div>
        <div style="color:#f56c6c;padding-left:60px" v-show="selfconfig.isLimitIp == 1">*或空表示不限制ip</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <button @click="addto(digdata)" class="selfbtn">确 定</button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import utils from "@/utils/utils.js";
import {
  getApis,
  subReview,
  getBaisc,
  changeIp,
  changeIsip,
  notempty,
  cancelApis,
  editip,
} from "@/apis/console.js";
export default {
  name: "api",
  data() {
    return {
      tab_index: 2,
      apisCanSubscription: {
        tableData: [],
        total: 0,
        pageSize: 10,
        page: 1,
      }, // 可订阅api数据分页参数
      apisAlreadySubscription: {
        tableData: [],
        total: 0,
        pageSize: 10,
        page: 1,
      }, // 已订阅api数据分页参数
      list: [],
      addList: [], // 已添加数据
      isSub: false,
      isAuth: -1,
      addipGroup: false, //新增ip组弹窗
      digdata: {}, //弹窗数据
      selfconfig: { title: "",type: 0,isLimitIp:0},
      status: "",
      addForm: {
        one: "*",
        // two:'',
        moreInput: [
          {
            value: "",
          },
        ],
      },
      ruleForm: {
        one: [{ required: false, validator: changeIp, trigger: "blur" }],
        oneIP: [{ required: false, validator: changeIsip, trigger: "blur" }],
      },
      selfrule: {
        Ipruleone: [{ required: false, validator: changeIp, trigger: "blur" }],
        IpruleoneIP: [{ required: false, validator: changeIsip, trigger: "blur" }],
      },
    };
  },

  components: {
    //组件声明
  },

  computed: {
    //计算属性
  },

  created() {
    //创建时执行
    this.getApis();
    this.addForm.moreInput = [];
  },

  mounted() {
    //数据挂载
  },

  methods: {
    //函数声明
    /** 获取api */
    getApis() {
      getApis(this).then((res) => {
        if (res.success) {
          this.isAuth = 2;
          this.list = res.data;
          console.log(this.status);
          if (this.status == 1) {
            this.page(this.list);
            // this.page(this.addList);
          } else {
            this.page(this.list);
          }
        } else {
          this.isAuth = 1;
        }
      });
    },
    /** 分页 */
    page(data) {
      let tableData = data; // api数据
      let total = tableData.length; // 总数量
      let page =
        this.tab_index == 2
          ? this.apisCanSubscription.page
          : this.apisAlreadySubscription.page; // 当前页
      let sizeArray = (
        total /
        (this.tab_index == 2
          ? this.apisCanSubscription.pageSize
          : this.apisAlreadySubscription.pageSize)
      )
        .toString()
        .split(".");
      let size = parseInt(sizeArray[0]) + (!parseInt(sizeArray[1]) ? 0 : 1);
      let pageSize =
        this.tab_index == 2
          ? this.apisCanSubscription.pageSize
          : this.apisAlreadySubscription.pageSize; // 每页展示条数
      let list = [];
      for (let i = (page - 1) * pageSize; i < page * pageSize; i++) {
        if (tableData[i]) {
          list.push(tableData[i]);
        }
      }
      if (page > 1 && !list.length) {
        if (this.tab_index == 2) {
          this.apisCanSubscription.page = page - 1;
        } else {
          this.apisAlreadySubscription.page = page - 1;
        }
        this.page(data);
        return;
      }
      if (this.tab_index == 2) {
        this.apisCanSubscription.total = total;
        this.apisCanSubscription.tableData = list;
      } else {
        this.apisAlreadySubscription.total = total;
        this.apisAlreadySubscription.tableData = list;
      }
    },

    /** 切换tab页 */
    changeTab(index) {
      this.tab_index = index;
      this.status = index;
      if (index == 1) {
        this.status = index;
        // this.page(this.addList);
      } else {
        this.status = "";
        // this.page(this.list);
      }
      console.log("单击获取status", this.status);
      this.getApis();
    },
    // 改变每页显示条数
    sizeChange(e) {
      if (this.tab_index == 2) {
        this.apisCanSubscription.pageSize = e;
        this.apisCanSubscription.size = 1;
        this.getApis();
      } else {
        this.apisAlreadySubscription.pageSize = e;
        this.apisAlreadySubscription.size = 1;
        this.getApis();
        // this.page(this.list);
      }
    },
    // 当前页
    currentChange(e) {
      if (this.tab_index == 2) {
        this.apisCanSubscription.page = e;
        this.getApis();
      } else {
        this.apisAlreadySubscription.page = e;
         this.getApis();
        // this.page(this.addList);
      }
    },

    toDetails(query) {
      let newpage = this.$router.resolve({
        path: "/api/apiDoc",
        query:{apiCode:query.apiCode},
      });
      window.open(newpage.href, "_blank");
    },

    /** 页面跳转 */
    toLink(path) {
      this.$router.push(path);
    },
    //弹窗关闭
    handleClose(done) {
      done();
      this.$nextTick(() => {
        this.$refs.dtform.resetFields();
      });
    },
    /** '申请 */
    add(data) {
      this.selfconfig.title = "申请API";
      this.selfconfig.type = 1;
      this.selfconfig.isLimitIp = data.isLimitIp 
      data.isLimitIp == 1 ? this.addForm.one = "*" : this.addForm.one = "";
      this.digdata = data;
      this.addipGroup = true;
      this.$nextTick(() => {
        this.addForm.moreInput = [];
      });
    },
    /** 编辑 */
    edit(data) {
      this.selfconfig.title = "编辑API配置";
      this.selfconfig.type = 2;
      this.digdata = data;
      let editArr = data.limitIp.split(",");
      editArr = notempty(editArr);
      this.addForm.one = editArr[0];
      let thidstart = editArr.slice(1);
      this.addForm.moreInput = thidstart.map((item) => {
        return {
          value: item,
        };
      });
      this.addipGroup = true;
    },
    /** IP白名单确定按钮 */
    addto(digdata) {
      console.log(digdata);
      this.$refs.dtform.validate((valid) => {
        if (valid) {
          let ipgroup = [this.addForm.one];
          for (let i = 0, len = this.addForm.moreInput.length; i < len; i++) {
            if (this.addForm.moreInput[i].value) {
              ipgroup.push(this.addForm.moreInput[i].value);
            }
          }
          debugger
          digdata.ipgroup = ipgroup.join(",");
          this.addipGroup = false;
          let list = this.list;
          let addList = this.addList;

          if (addList.indexOf(digdata) == -1) {
            addList.push(digdata);
          }
          if (this.selfconfig.type == 1) {
            // 删除操作
            utils.removeArray(list, digdata);
            this.page(list);
            this.subReview(); //申请审核
          } else {
            this.page(this.addList);
            editip(this, digdata.apiCode, digdata.ipgroup ).then((res) => {
              if (res.success) {
                this.getApis();
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    remove(data) {
      this.del_id = data.apiCode;
      let list = this.addList;
      let removeList = this.list;
      if (removeList.indexOf(data) == -1) {
        removeList.push(data);
      }
      cancelApis(this).then((res) => {
        if (res.success) {
          this.$message.success("取消申请成功!")
          this.getApis();
        }
      });
      // 删除操作
      // utils.removeArray(list, data);
      // this.page(list);
    },
    /** 动态添加input */
    addinput() {
      if (this.addForm.moreInput.length < 14) {
        this.addForm.moreInput.push({ value: "" });
      } else {
        return;
      }
    },
    removeinput() {
      if (this.addForm.moreInput.length <= 0) {
        return;
      } else {
        this.addForm.moreInput.pop({ value: "" });
      }
    },
    subReview() {
      if (!this.addList.length) {
        this.$message.warning("您还没有添加api");
        return;
      }
      let apiList = [];
      this.addList.forEach((item) => {
        apiList.push({ apiCode: item.apiCode, limitIp: item.ipgroup });
      });
      subReview(this, apiList).then((res) => {
        if (res.success) {
          this.isSub = true;
        }
      });
    },
    /** 刷新 */
    Refresh() {
      window.location.reload();
    },
  },
};
</script>
<style lang='less' scoped>
.api {
  .tabs {
    display: flex;
    border-bottom: 1px solid #ebebec;

    .tab {
      height: 44px;
      line-height: 44px;
      width: 90px;
      text-align: center;
      box-sizing: border-box;
      cursor: pointer;
      color: #bfbfbf;
      font-size: 16px;
      margin-right: 25px;
    }

    .active {
      color: #333333;
      border-bottom: 2px solid #fabe00;
    }
  }

  .table {
    padding-top: 20px;

    .link {
      cursor: pointer;
      color: #409eff;
    }

    .ops {
      display: flex;
      justify-content: center;
      .btn {
        width: 100%;
        cursor: pointer;
        color: #9aabe1;
        text-align: center;
      }
      .btn:nth-of-type(2) {
        margin-left: 10px;
      }
      .del {
        color: #f49b98;
      }
      .no {
        pointer-events: none;
        cursor: default;
        color: #ebeae8;
      }
    }

    .status {
      font-size: 14px;
      color: #333333;
      display: flex;
      align-items: center;

      span {
        display: inline-block;
        width: 6px;
        height: 6px;
        border-radius: 100%;
        margin-right: 10px;
      }
    }
    .nosub {
      span {
        background: #fabe00;
      }
    }
    .subing {
      span {
        background: #476ff2;
      }
    }
    .pass {
      span {
        background: #75bd65;
      }
    }
    .unpass {
      span {
        background: #ff6f6f;
      }
    }

    .page {
      padding: 25px 0;
      display: flex;
      justify-content: flex-end;

      /deep/.el-pagination__total {
        line-height: 30px;
        padding-left: 15px;
      }

      /deep/.el-pager {
        /deep/li {
          background: #fff;
          border: 1px solid #ebebec;
          line-height: 28px;
          font-weight: normal;
        }
        /deep/.active {
          background: #fabe00;
          border-color: #fabe00;
        }
      }
      /deep/.btn-prev,
      /deep/.btn-next {
        background: #fff;
        border: 1px solid #ebebec;
      }
    }
  }

  .sub {
    margin: 15px 0;
    display: flex;
    justify-content: center;

    .btn {
      width: 140px;
      height: 46px;
      line-height: 46px;
      background: #fabe00;
      border-radius: 2px;
      color: #333333;
      text-align: center;
      margin-right: 20px;
      -moz-user-select: none; /*火狐*/
      -webkit-user-select: none; /*webkit浏览器*/
      -ms-user-select: none; /*IE10*/
      -khtml-user-select: none; /*早期浏览器*/
      user-select: none;
      cursor: pointer;
    }
  }

  .sub_success {
    .content {
      text-align: center;
      .tips {
        color: #999999;
        font-size: 12px;

        .title {
          font-size: 16px;
          color: #333333;
          padding-bottom: 10px;
        }
      }

      img {
        width: 98px;
        height: 98px;
      }
    }
    .btn {
      width: 164px;
      height: 34px;
      line-height: 34px;
      border: 1px solid rgba(250, 190, 0, 1);
      box-shadow: 0px 3px 12px rgba(250, 190, 0, 0.5);
      border-radius: 2px;
      text-align: center;
      margin: 20px auto;
      cursor: pointer;
    }
  }

  .noAuth {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding-top: 240px;

    img {
      width: 163.5px;
      height: 142.4px;
    }

    .e {
      color: #666666;
      font-size: 16px;
      padding: 10px 0;
    }

    .btn {
      margin: 20px;
      width: 164px;
      height: 34px;
      border: 1px solid rgba(250, 190, 0, 1);
      box-shadow: 0px 3px 12px rgba(250, 190, 0, 0.5);
      border-radius: 2px;
      cursor: pointer;
      color: #fabe00;
      font-size: 14px;
      line-height: 34px;
      text-align: center;
    }
  }
}
.diaBody {
  display: flex;
  flex-direction: column;
  .diatop {
    height: 102px;
    li {
      display: flex;
      justify-content: flex-start;
      line-height: 32px;
      height: 32px;
      .left {
        width: 160px;
        box-sizing: border-box;
        padding-left: 60px;
        text-align: left;
      }
      .right {
        flex: 1;
      }
    }
  }
  .digbottom {
    flex: 1;
    position: relative;
    .b_left {
      width: 160px;
      box-sizing: border-box;
      float: left;
      padding-left: 60px;
      height: 100%;
    }
    .b_right {
      width: 260px;
      float: left;
      .checkInput {
        .errortip {
          height: 14px;
          line-height: 14px;
          font-size: 12px;
          color: red;
        }
      }
    }
    .b_btns {
      position: absolute;
      right: 32px;
      width: 60px;
      height: 100%;
      top: 2px;
      // padding-bottom:23px;
      box-sizing: border-box;
      display: flex;
      // flex-direction: column;
      justify-content: space-between;
      p {
        width: 25px;
        height: 25px;
        line-height: 25px;
        background: #fabe00;
        text-align: center;
        border-radius: 4px;
      }
    }
    .ipInput {
      width: 250px;
    }
  }
}
.selfbtn {
  width: 200px;
  color: #ffffff;
  height: 30px;
  background: rgba(250, 190, 0, 1);
  border: 1px solid rgba(250, 190, 0, 1);
  box-shadow: 0px 3px 12px rgba(250, 190, 0, 0.5);
  border-radius: 4px;
  font-size: 14px;
}
.hasWhites{
  color:#F56C6C;
  font-size: 14px;
  cursor: pointer;
  &:hover{
    text-decoration: underline;
  }
}
</style>